/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row, Table } from "react-bootstrap"
import CONSTANT from "../../constant"
import { e支払先区分, T支払先区分名称 } from "../../constant/enum/master"

import SiharaisakiService from "../../service/master/siharaisaki/siharaisakiService"
import { 支払先マスタ } from "../../service/master/siharaisaki/TSiharaisaki"

import { TWijmoCellTemplateContext } from "../../type/wijmoComponents"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../FlexGridWrapper/GridFooter"
import TextInput from "../InputWrapper/TextInput"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"
import Spinner from "../Spinner"

/**
 * 支払先検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const SiharaisakiSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    footer?: React.ReactNode
    siharaisakiName?: string
    siharaisakiKubun: T支払先区分名称
    setSiharaisaki: (value: 支払先マスタ) => unknown
  }
> = (props) => {
  //#region [state]
  // 検索項目
  const [支払先名, set支払先名] = useState<string>()
  const [支払先コード, set支払先コード] = useState<string>()

  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async (searchCondition?: { 支払先名?: string }) => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    try {
      const res = await new SiharaisakiService().getList({
        支払先名: searchCondition?.支払先名 ?? 支払先名,
        支払先コード: 支払先コード,
        支払先区分コード: e支払先区分[props.siharaisakiKubun],
      })

      const newData = createCollectionView([...res.data], pageSize)
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: 支払先マスタ) => {
    props.setSiharaisaki(item)
    props.setIsShow(false)
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null) return

    if (props.isShow) {
      console.log(props)
      //表示時
      // 支払先名が設定されている場合、そのParameterで検索
      if (!wjcCore.isNullOrWhiteSpace(props.siharaisakiName ?? "")) {
        set支払先名(props.siharaisakiName)

        search({ 支払先名: props.siharaisakiName })
      }
    } else {
      // 非表示時中身を空にして閉じる
      set支払先名("")
      const newData = {
        data: createCollectionView([], pageSize),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid])

  useEffect(() => {}, [])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={`${props.siharaisakiKubun}検索`}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <Table className="form-table">
                <tbody>
                  <tr>
                    <th className="min-w-4rem">支払先</th>
                    <td colSpan={6}>
                      <div className="input-group d-flex">
                        <TextInput
                          style={{ width: "14rem" }}
                          id="支払先コード"
                          name="支払先コード"
                          value={支払先コード}
                          setValue={set支払先コード}
                          maxLength={15}
                          placeholder="コード"
                        />
                        <TextInput
                          style={{ width: "20rem" }}
                          id="支払先名"
                          name="支払先名"
                          value={支払先名}
                          setValue={set支払先名}
                          maxLength={100}
                          placeholder="名称"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col className="mt-2 mb-2">
              <Button
                type="submit"
                onClick={(e) => {
                  e.preventDefault()
                  search()
                }}>
                <FontAwesomeIcon icon={faSearch} />
                検索
              </Button>
            </Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "20rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                header="選択"
                align={"center"}
                binding="支払先ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(
                    context: TWijmoCellTemplateContext<支払先マスタ>
                  ) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={110}
                header="支払先CD"
                binding="支払先コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={250}
                header="支払先名"
                binding="支払先名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={150}
                header="支払先略称"
                binding="支払先略称"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="郵便番号"
                binding="郵便番号"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="住所１"
                binding="住所１"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="住所２"
                width={170}
                binding="住所２"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="住所３"
                width={200}
                binding="住所３"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="住所"
                width={300}
                binding="住所"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="電話番号"
                width={150}
                binding="電話番号"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="FAX番号"
                width={150}
                binding="FAX番号"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="支払先担当者"
                width={150}
                binding="支払先担当者"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default SiharaisakiSearchModal
